// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sIax","icon":"styles_icon__30azf"};